export default "__VITE_ASSET__ahpS7XwS__";